const values = {
    fullname: '',
    address: '',
    appartment: '',
    zipcode: '',
    city: '',
    phone: '',
    email: '',
    date: 'defaultdate',
    website: process.env.REACT_APP_WEBSITE,
    reference: process.env.REACT_APP_REFERENCE,
    buildingType: 'defaultbuilding',
    singlefamily: {
        evready: 'defaultevready',
        evreadyyes: {
            breakersize: 'defaultbreakersize',
            nbstations: 'defaultnbstations',
            next5years: 'defaultnext5years',
            panellocation: 'defaultpanellocation',
            panellocationsothers: {
                panellocationspecify: ''
            },
            otherpanels: 'defaultotherpanels',
            otherpanelsyes: {
                otherpanelsspecify: ''
            },
            chargingstationlocation: 'defaultchargingstationlocation',
            otherlocationspecify: {
                chargingstationlocationspecify: ''
            },
            distancepanel: '',
            distanceunits: 'defaultdistanceunits',
        },
        
        knowmodel: 'defaultknowmodel',
        knowmodelyes: {
            knowmodelspecify: ''
        },
        knowmodelno: {
            maxpower: 'defaultmaxpower'
        },
        maxpoweridk: {
            maxpowercarmodel: ''
        },
        files: []
    },
    singlecondo: {
        condoassociation: 'defaultcondoassociation',
        nbstations: 'defaultnbstations',
        hydrometerlocation: 'defaulthydrometerlocation',
        hydrometerlocationothers: {
            hydrometerlocationspecify: ''
        },
        chargingstationlocation: 'defaultchargingstationlocation',
        otherlocationspecify: {
            chargingstationlocationspecify: ''
        },
        distancepanel: '',
        distanceunits: 'defaultdistanceunits',
        knowmodel: 'defaultknowmodel',
        knowmodelyes: {
            knowmodelspecify: ''
        },
        files: []
    },
    serverError: ''
}

export default values;